import { Box, Button, CircularProgress, Fab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";
import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { clientsActions } from "../../../actions/clients.actions";
import ClientsList from "../../../components/clients/ClientsList";
import HeaderTitle from "../../../components/HeaderTitle";
import SearchList from "../../../components/searchList";
import ClientsEdit from "../../../containers/admin/clients/ClientsEdit";
import ClientsNew from "../../../containers/admin/clients/ClientsNew";
import ClientsShow from "../../../containers/admin/clients/ClientsShow";
import { filterElement, selectClients } from "../../../helpers/schema";

export default function Index(props) {
  const dispatch = useDispatch();
  const [searchFilter, setSearchFilter] = React.useState("");
  const [loadItems, _setLoadItems] = React.useState(50);

  const loadItemsRef = React.useRef(loadItems);
  const setLoadItems = (data) => {
    loadItemsRef.current = data;
    _setLoadItems(data);
  };

  const isFetching = useSelector((state) => {
    return state.clients.isFetching;
  }, shallowEqual);

  const clients = useSelector((state) => {
    return Object.values(selectClients(state)) || [];
  }, shallowEqual);

  useEffect(() => {
    dispatch(clientsActions.fetchClientsIfNeeded());
  });

  const handleRefreshClick = (event) => {
    event.preventDefault();

    dispatch(clientsActions.invalidateClients());
    dispatch(clientsActions.fetchClientsIfNeeded());
  };

  const onSearch = (search) => {
    setSearchFilter(search);
    setLoadItems(50);
  };

  const onScrollEnd = () => {
    setLoadItems(loadItemsRef.current + 50);
  };

  return (
    <Switch>
      <Route exact path="/renov/clients">
        <HeaderTitle
          mb={3}
          title="Clients"
          right={
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleRefreshClick}
              startIcon={<RefreshIcon />}
              disabled={isFetching}
            >
              Actualiser
            </Button>
          }
          bottom={<SearchList onScrollEnd={onScrollEnd} onSearch={onSearch} />}
        />
        {isFetching && Object.entries(clients).length === 0 && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexGrow={1}
          >
            <CircularProgress size={100} />
          </Box>
        )}
        <div className={"clients-container"}>
          {!isFetching && Object.entries(clients).length === 0 && (
            <h2>Aucune donnée disponible.</h2>
          )}

          {Object.entries(clients).length > 0 && (
            <ClientsList
              clients={Object.values(clients)
                .filter((item) =>
                  filterElement(
                    item,
                    ["name", "email", "city", "postCode"],
                    searchFilter
                  )
                )
                .slice(0, loadItems)}
            />
          )}

          <Box position="fixed" bottom={30} right={30}>
            <Fab
              color="primary"
              aria-label="add"
              component={Link}
              to={"/renov/clients/new"}
            >
              <AddIcon />
            </Fab>
          </Box>
        </div>
      </Route>
      <Route path={"/renov/clients/:clientId/show"} children={<ClientsShow />} />
      <Route path={"/renov/clients/new"} children={<ClientsNew />} />
      <Route path={"/renov/clients/:clientId/edit"} children={<ClientsEdit />} />
      <Route>
        <Redirect to={"/renov/clients"} />
      </Route>
    </Switch>
  );
}
